import * as constants from '@/store/constants'
import * as types from '@/store/types'
import store from '@/store'
import service from '@/api/AirService'



export default {
	[types.ACTION_ADD_AIR]: ({commit}, payload) => {
    	service.addAir(payload)
    },
    [types.ACTION_UPDATE_AIR]: ({commit}, payload) => {
        service.updateAir(payload).then( (response)=> {
            if (response) {
                store.commit(types.MUTATE_AIR, response)
                store.commit(types.MUTATE_MODIFIED, false)
           }
        })
    },
    [types.ACTION_FIND_AIR]: ({commit}, payload) => {
        service.fetchByNotificationId(payload)
        .then( (response) => {            
            if (response) {
                commit(types.MUTATE_AIR, response)
            }            
        })
    }    
}


// WEBPACK FOOTER //
// ./src/store/modules/air/actions.js